import React, { useEffect } from "react";
import * as S from "./style";

function Swiper() {
  return (
    <S.Container>
      <section id="slider">
        <input type="radio" name="slider" id="s1" />
        <input type="radio" name="slider" id="s2" />
        <input type="radio" name="slider" id="s3" defaultChecked={true} />
        <label htmlFor="s1" id="slide1">1</label>
        <label htmlFor="s2" id="slide2">2</label>
        <label htmlFor="s3" id="slide3">3</label>
      </section>
    </S.Container>
  );
}

export default Swiper;
